export type leftType = 'left';
export type rightType = 'right';

export const LEFT = 'left';
export const RIGHT = 'right';
